/**
 * Check buttons list component script
 */
export const ExpandableCard = (function () {
    
    var init = function () {
        $('.expandable-card .btn.expand').on('click', function(){ 
          
            $(this).closest('.expandable-card').find('.sliced, .unsliced').toggleClass('d-none');
            return false;
        });
    };

    return {
      init: init,
    };
  })();
  